import { useTranslation } from 'react-i18next';

import type { AuctionOutcome, AuctionStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const SUCCESS = 'bg-success/15 text-success border-transparent dark:bg-success/20';
const NEUTRAL = 'border-border text-muted-foreground';
const INFO = 'bg-primary/10 text-foreground border-transparent';
const WARNING = 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25';
const DANGER = 'bg-destructive/10 text-destructive border-transparent';

const STATUS: Record<AuctionStatus, string> = {
  draft: NEUTRAL,
  scheduled: INFO,
  live: SUCCESS,
  ended: NEUTRAL,
  cancelled: DANGER,
};

const OUTCOME: Record<AuctionOutcome, string> = {
  sold: SUCCESS,
  no_sale: WARNING,
  cancelled: DANGER,
};

export function AuctionStatusBadge({
  status,
  className,
}: {
  status: AuctionStatus;
  className?: string;
}) {
  const { t } = useTranslation('auctions');
  return (
    <Badge variant="outline" className={cn(STATUS[status], className)}>
      {status === 'live' ? (
        <span aria-hidden className="bg-success size-1.5 animate-pulse rounded-full" />
      ) : null}
      {t(`status.${status}`)}
    </Badge>
  );
}

export function AuctionOutcomeBadge({
  outcome,
  className,
}: {
  outcome: AuctionOutcome;
  className?: string;
}) {
  const { t } = useTranslation('auctions');
  return (
    <Badge variant="outline" className={cn(OUTCOME[outcome], className)}>
      {t(`outcome.${outcome}`)}
    </Badge>
  );
}
